import Vue from 'vue';

Vue.directive('inputAutoResize', {

  inserted: function (el: any) {
    let _input = el;
    if (el.tagName != 'INPUT') {
      _input = el.querySelector('input');
    }
    el.style.width = '100px';
    el.style.minWidth = '80px';
    const paddingLeft = parseInt(window.getComputedStyle(_input)['paddingLeft'] || '0px');
    const paddingRight = parseInt(window.getComputedStyle(_input)['paddingRight'] || '0px');
    const fontSize = parseInt(window.getComputedStyle(_input)['fontSize'] || '0px');
    _input.onfocus = () => {
      _input.value.length && (el.style.width = (_input.value.length * fontSize) + paddingLeft + paddingRight + 'px');
    }
    _input.oninput = () => {
      el.style.width = (_input.value.length * fontSize) + paddingLeft + paddingRight + 'px';
    }
  }
});